module.exports = __webpack_public_path__ + "img/42_46.db25ad12.png";